var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.onlyIcon)?_c('el-button',{attrs:{"round":"","type":_vm.is_on ? 'info' : 'warning',"size":"small","icon":_vm.icon},on:{"click":_vm.tolog}},[_vm._v(_vm._s(_vm.is_on ? '取消收藏' : '收藏'))]):_c('i',{staticClass:"hand",class:_vm.is_on ? _vm.onClass : _vm.offClass,on:{"click":_vm.tolog}})
}
var staticRenderFns = []

export { render, staticRenderFns }